"use client";

import {
  isAdventCalendarCampaign,
  isBibliobattlesCampaign,
  isCustomCampaign,
  isLitteraturprisCampaign,
  isSommerlesCampaign,
} from "@libry-content/common";
import AdventCalendarView from "../../../../../../components/adventCalendar/AdventCalendarView";
import { BibliobattlesView } from "../../../../../../components/campaigns/bibliobattles/BibliobattlesView";
import { CustomCampaignView } from "../../../../../../components/campaigns/customCampaign/CustomCampaignView";
import { DefaultPageLayout } from "../../../../../../components/layout/DefaultPageLayout";
import { SommerlesView } from "../../../../../../components/sommerles/SommerlesView";
import { SanityDataWithPreviewConfig } from "../../../../../sanityFetcher/getAppFolderPageProps";
import { SanityPreviewLiveQuery } from "../../../../../sanityFetcher/SanityPreviewLiveQuery";
import { CampaignPageData } from "./page";
import { LitteraturprisView } from "../../../../../../components/campaigns/litteraturpris/LitteraturprisView";
import { Box } from "@biblioteksentralen/react";
import { SommerlesApiStats } from "../../../../../../components/sommerles/SommerlesStats";

type Props = {
  sanityData: SanityDataWithPreviewConfig<CampaignPageData>;
  sommerlesApiStats?: SommerlesApiStats;
  hasSommerlesPopularReading?: boolean;
};

export const ClientSideCampaign = (props: Props) => (
  <SanityPreviewLiveQuery sanityData={props.sanityData}>
    {({ campaign }) => (
      <Box background={isSommerlesCampaign(campaign) ? "#F8EEDF" : undefined}>
        <DefaultPageLayout>
          {isCustomCampaign(campaign) && <CustomCampaignView customCampaign={campaign} />}
          {isSommerlesCampaign(campaign) && (
            <SommerlesView
              sommerles={campaign}
              sommerlesApiStats={props.sommerlesApiStats}
              hasSommerlesPopularReading={props.hasSommerlesPopularReading}
            />
          )}
          {isAdventCalendarCampaign(campaign) && <AdventCalendarView adventCalendar={campaign} />}
          {isBibliobattlesCampaign(campaign) && <BibliobattlesView bibliobattles={campaign} />}
          {isLitteraturprisCampaign(campaign) && <LitteraturprisView litteraturpris={campaign} />}
        </DefaultPageLayout>
      </Box>
    )}
  </SanityPreviewLiveQuery>
);
